import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { SearchPasscodeListMembers } from '@/connection/audiences/passcode-lists';

export const searchPasscodeListMembers = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({
      passcodeListId,
      offset,
      order,
      search,
    }: {
      passcodeListId: number;
      offset: number;
      order: number;
      search: string;
    }) => {
      const passcodeListMembers = await SearchPasscodeListMembers(passcodeListId, offset, order, search);
      return passcodeListMembers;
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.passcodeListMembers = action.payload || [];
        }
        state.loadingPasscodeListMembers = false;
      },
      pending: (state) => {
        state.loadingPasscodeListMembers = true;
      },
      rejected: (state, action) => {
        state.loadingPasscodeListMembers = false;
        console.error(action.error);
      },
    }
  );
